import { render, staticRenderFns } from "./weekly-data-report.vue?vue&type=template&id=b8d575b4"
import script from "./weekly-data-report.vue?vue&type=script&lang=js"
export * from "./weekly-data-report.vue?vue&type=script&lang=js"
import style0 from "./weekly-data-report.vue?vue&type=style&index=0&id=b8d575b4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports